import Copains from './Copains'

export default Copains